import React, { useEffect, useState } from "react";

import { Box, TextField } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";
// import { setSelectedOption } from "../../../../../../../../redux/actions/corporateSurvey/corporateSurveyActions";

const CommentBox = ({
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  useEffect(() => {
    if (submittedAnswer) {
      setInputValue(submittedAnswer[0]?.option);
      setCommentBox(submittedAnswer[0]?.comment);
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const placeholderSize = {
    inputProps: {
      sx: { fontSize: "14px" }, // Adjust placeholder font size
    },
  };

  const labelSize = {
    style: { fontSize: "14px" }, // Adjust label font size
  };
  const handleChange = (type, value) => {
    if (type === "option") setInputValue(value);
    if (type === "comment") setCommentBox(value);
    if (type === "document") setAttachDocument(value);

    if (isFrom === "taskSection") {
      const obj = {
        option: type === "option" ? value : inputValue,
        comment: type === "comment" ? value : commentBox,
        supporting_document:
          type === "document" && value === null ? value : attachDocument,
        document: type === "document" ? value : attachDocument,
        documentMetaData:
          type === "document"
            ? {
                ques_id: question?._id,
                name: value?.name,
                is_supporting_document: true,
                type: value?.type,
              }
            : null,
        weightage: 1,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  return (
    <Box
      mt={2}
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <AdvancedInputField
        data={inputValue}
        placeholder="Comment"
        name="option"
        handleChange={({ name, value }) => handleChange(name, value)}
      />
      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default CommentBox;
